import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ['수립연도', "소관부서", "작성일", "첨부파일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let year = search.year;
    conditions.push({ key: "header.year", operator: "=", value: `${year}` });

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "수립연도",
        key: "header.year",
      },
      {
        name: "시설명",
        key: "body.시설명[%].field_name",
      },
      {
        name: "소관부서",
        key: "body.시설명[%].meta",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
      {
        name: "첨부파일",
        key: "body.fileList",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      const postContent = JSON.parse(value.post_content);
      switch (index) {
        case 0: return postContent.header.year; // 수립연도
        case 1: {
          const fields = func.getContent(value).시설명.map((item) => {
            return item.field_name;
          });
          return fields.join(", ");
        } // 시설명
        case 2: {
          const body = func.getContent(value)
          if (body.시설명 && body.시설명.length > 0) {
            const 소관부서 = body.시설명.map((item) => {
              const meta = item.meta ? JSON.parse(item.meta) : {};
              return meta.소관부서;
            });
            return [...new Set(소관부서)].join(', ')
          }
          return ""
        } // 소관부서
        case 3: return func.getContent(value).stdInfo.writer_name; // 작성자
        case 4: return func.getCreatedDate(value.created_at); // 작성일
        case 5: {
          return { type: 'file', files: func.getContent(value).fileList}
        }
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
